import { get } from "lodash-es";
import type {
  Maybe,
  BasicTeam,
  GetHeadToHeadTeamStatsTabQuery,
} from "@/graphql/gql/graphql";

export const teamDataToSuccessRateStats = (team?: Maybe<BasicTeam>) => {
  const stats = get(team, "teamStats.successStats.rankedStats", {});

  return {
    team: {
      abbreviation: get(team, "abbreviation", ""),
      logoSVG: get(team, "logoSVG", ""),
    },
    offense_value: get(stats, "offense.value", 0),
    offense_rank: get(stats, "offense.rank", 0),
    passing_value: get(stats, "passing.value", 0),
    passing_rank: get(stats, "passing.rank", 0),
    rushing_value: get(stats, "rushing.value", 0),
    rushing_rank: get(stats, "rushing.rank", 0),
    defense_value: get(stats, "defense.value", 0),
    defense_rank: get(stats, "defense.rank", 0),
    pass_defense_value: get(stats, "passDefense.value", 0),
    pass_defense_rank: get(stats, "passDefense.rank", 0),
    rush_defense_value: get(stats, "rushDefense.value", 0),
    rush_defense_rank: get(stats, "rushDefense.rank", 0),
  };
};

export const createTableData = (
  data?: GetHeadToHeadTeamStatsTabQuery["event"]
) => {
  const homeTeam = data?.homeTeam;
  const awayTeam = data?.awayTeam;
  const homeStats = teamDataToSuccessRateStats(homeTeam);
  const awayStats = teamDataToSuccessRateStats(awayTeam);

  return [homeStats, awayStats];
};
